import React, { Component } from 'react'

import * as utils from "../utils";

import { Link } from 'react-router';
import { connect } from 'react-redux';

// TODO better way to do this?  (see below)
const mobileNeedsMoreTabNames = ['what-to-bring', 'polls', 'gifts', 'donate', 'settings'];  // is that all of 'em?

const EventViewTabs = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    if (utils.isMobile()) {
      return true;
    }
    return this.state.showMore !== nextState.showMore;
  },
  getInitialState: function() {
    return {
      showMore: false
    }
  },
  componentDidMount: function() {
    const ad = document.getElementById('ad_mobile_top');

    if (evite.detects.isMobile && !evite.experiments.inExperiment('sticky_header')) {
      setUpForHeaderScrolling();
      if (ad) {
        // if there's an ad in the header, call the set up func again to adjust layout
        evite.when('ad-mobile-top').then(() => {
          setUpForHeaderScrolling();
        });
      }
    }
    evite.resolve('view-invitation-loaded');
  },
  render: function() {
    const { hasPoll, hasWhatToBring } = this.props.state;
    const isHost = utils.isHost();
    const isMobile = utils.isMobile();
    const showPolls = hasPoll || isHost;
    const showWhatToBring = hasWhatToBring || isHost;
    const showDonate = window.donations_enabled == true;
    const showGifts = (window.wishlist_enabled == true) ||
                      window.evite_event.options.event_option_show_gifting ||
                      (window.evite_event.registries && window.evite_event.registries.length) ||
                      window.has_sponsored_registry;
    const mobileClass = isMobile ? `mobile-event-view-tabs${ window.is_premium ? " premium" : " free"}` : "";
    const needsMore = isMobile && (showPolls || showWhatToBring || showDonate || showGifts);
    const showSecondaryNav = !isMobile || (isMobile && this.state.showMore);
    // TODO better way to do this? For making the "more" tab active on mobile
    // web when one of the "more" (hidden) items is active.
    const currentTabName = window.location.pathname.split('/').pop();
    const moreTabActive = mobileNeedsMoreTabNames.indexOf(currentTabName) > -1;
    const moreTabClasses = moreTabActive ? "active" : "";
    const tabIconSuffix = isMobile ? "_mw" : "";

    return (
      <nav className={`simple-shadowbox event-view-tabs ${mobileClass}`} id="event_view_tabs">
        <ul className="primary-nav">
          <LinkItem urlPart="rsvp" displayText="RSVP" iconName={`icon-details${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          <LinkItem urlPart="activity" displayText="Activity" iconName={`icon-activity${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          <LinkItem urlPart="photos" displayText="Photos" iconName={`icon-photos${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          <LinkItem urlPart="guestlist" displayText="Guests" iconName={`icon-guests${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          { needsMore &&
            <li className="event-view-tab">
              <a href="#" onClick={this.handleMoreClick} className={moreTabClasses}>
                <i className={`icon-more${tabIconSuffix}`}></i> More
              </a>
            </li>
          }
          { isMobile && !needsMore &&
            <LinkItem urlPart="settings" displayText="Settings" iconName={`icon-edit_event${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          }
        </ul>
        { showSecondaryNav &&
          <ul className="secondary-nav">
            { showWhatToBring &&
              <LinkItem urlPart="what-to-bring" displayText="What To Bring" iconName={`icon-wtb${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            { showPolls &&
              <LinkItem urlPart="polls" displayText="Poll" iconName={`icon-polls${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            { showDonate &&
              <LinkItem urlPart="donate" displayText="Donate" iconName={`icon-donations${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            { showGifts &&
              <LinkItem urlPart="gifts" displayText="Gifts" iconName={`icon-gifts${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
            }
            <LinkItem urlPart="settings" displayText="Settings" iconName={`icon-edit_event${tabIconSuffix}`} handleLinkClick={this.handleLinkClick} />
          </ul>
        }
      </nav>
    )
  },
  handleMoreClick: function(e) {
    e.preventDefault();
    this.setState({
      showMore: !this.state.showMore
    })
  },
  handleLinkClick: function(e) {
    window.setTimeout(function() {
      window.dataLayer.push({
        'event': 'event_view_link_clicked',
        'destination_url': window.location.pathname,
        'tracking_src': "navigation-tab"
      });
    }, 500);
    if (utils.isMobile()) {
      this.setState({
        showMore: false
      })
    }
  }
});

function LinkItem(props) {
  const { urlPart, iconName, displayText } = props;
  return (
    <li className="event-view-tab">
      <Link
        to={utils.eventTabUrlPath(urlPart)}
        id={`tab-${urlPart}`}
        className="event-view-tab-link"
        activeClassName="active"
        onClick={props.handleLinkClick}
      >
        <i className={iconName}></i> {displayText}
      </Link>
    </li>
  )
}

function mapStateToProps(state) {
  return {
    state: {
      hasPoll: state.polls.length > 0,
      hasWhatToBring: state.whattobring.creator_id
    }
  }
};

function setUpForHeaderScrolling() {
  let headerSpacerElem = document.getElementById('header_spacer');
  const cookieElem = document.getElementById('cookie-warning');
  const mobileAdElem = document.getElementById('mobile_top_ad');
  const universalNavElem = document.querySelector('.universal-nav.mobile');
  const navTabsElem = document.querySelector('.mobile-event-view-tabs');
  const mobileAdHeight = mobileAdElem ? mobileAdElem.offsetHeight : 0;

  // calculate the spacer
  let totalHeaderHeight = 
    cookieElem.offsetHeight + 
    universalNavElem.offsetHeight + 
    navTabsElem.offsetHeight + 
    mobileAdHeight;

  evite.css(headerSpacerElem, {height: totalHeaderHeight});

  const maxMoveAmount = universalNavElem.offsetHeight;
  let hs_tabBarOffset = universalNavElem.offsetHeight;
  let hs_elemsOrigTop = (window.is_premium ? 0 : mobileAdHeight + cookieElem.offsetHeight);
  let hs_elemsMinTop = hs_elemsOrigTop - maxMoveAmount;
  
  let hs_lastScrollPos = 0;
  let hs_elemsCurrTop = hs_elemsOrigTop;
  
  moveElemTo(universalNavElem, hs_elemsCurrTop);
  moveElemTo(navTabsElem, hs_elemsCurrTop + hs_tabBarOffset);

  if (mobileAdHeight > 10) {
    document.addEventListener('scroll', event => {
      // the universal nav and tab bar get "nudged" up or down, if needed, by at
      // most scrollOffset at a time
      const scrollPos = window.pageYOffset;
      if (scrollPos < 0 || scrollPos === hs_lastScrollPos) {
        return; // invalid or no change in scroll position
      }
      const scrollOffset = hs_lastScrollPos - scrollPos;
      const scrollingDown = scrollPos > hs_lastScrollPos;
      const scrollingUp = scrollPos < hs_lastScrollPos;

      hs_lastScrollPos = scrollPos;

      const alreadyAtTop = hs_elemsCurrTop == hs_elemsMinTop;
      const alreadyAtOrigin = hs_elemsCurrTop == hs_elemsOrigTop;
      if (scrollingDown && alreadyAtTop || scrollingUp && alreadyAtOrigin) {
        return;   // no nudging needed
      }

      // adjust position by scrollOffset, then snap to top/bottom "rails" if needed
      hs_elemsCurrTop = hs_elemsCurrTop + scrollOffset;
      if (hs_elemsCurrTop < hs_elemsMinTop) {
        hs_elemsCurrTop = hs_elemsMinTop;
      }
      else if (hs_elemsCurrTop > hs_elemsOrigTop) {
        hs_elemsCurrTop = hs_elemsOrigTop;
      }
      moveElemTo(universalNavElem, hs_elemsCurrTop);
      moveElemTo(navTabsElem, hs_elemsCurrTop + hs_tabBarOffset);
    });
  }
}

function moveElemTo(elem, pos) {
  evite.css(elem, {position: 'fixed', top: pos});
}

export default connect(mapStateToProps)(EventViewTabs);



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/event-view-tabs/components.es6